<template>
  <div style="padding: 20px 20px 20px 0">
    <!-- 新增/修改弹框 -->
    <el-dialog :title="title" :visible.sync="show" width="500px" @close="close">
      <video
        style="width: 100%; height: 300px"
        :src="actionVideoPath"
        autoplay
        controls
      ></video>
      <span slot="footer" class="dialog-footer">
        <el-button @click="show = false">取 消</el-button>
      </span>
    </el-dialog>

    <!-- 新增/修改弹框 -->
    <el-dialog :title="title2" :visible.sync="show2" width="500px" @close="close">
      <!-- <div style="height: 300px;background-color: rgba(0,0,0,.1);"></div> -->
      <span>处理结果：</span>
      <el-input
        type="textarea"
        :autosize="{ minRows: 4, maxRows: 6 }"
        placeholder="请输入内容"
        v-model="resultDesc"
      >
      </el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="show2 = false">取 消</el-button>
        <el-button type="primary" @click="submitText">确 认</el-button>
      </span>
    </el-dialog>
    <!-- 搜索条件 -->
    <el-tabs v-model="statusAll" @tab-click="getAll">
      <el-tab-pane label="待处理" name="1"></el-tab-pane>
      <el-tab-pane label="已处理" name="2"></el-tab-pane>
    </el-tabs>
    <div>
      <el-form :inline="true" :model="selectForm" ref="selectForm">
        <el-form-item label="发生时间" prop="time">
          <el-date-picker
            v-model="time"
            type="daterange"
            range-separator="~"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
            style="width: 275px"
            size="small"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="事件类型" prop="actionType">
          <el-select
            clearable
            size="small"
            v-model="selectForm.actionType"
            placeholder="请选择"
            style="width: 100px"
          >
            <el-option
              v-for="item in typeList"
              :label="item.eventDesc"
              :value="item.type"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="事件等级" prop="actionLevel">
          <el-select
            size="small"
            v-model="selectForm.actionLevel"
            placeholder="请选择"
            style="width: 100px"
          >
            <el-option label="1" value="1"></el-option>
            <el-option label="2" value="2"></el-option>
            <el-option label="3" value="3"></el-option>
            <el-option label="4" value="4"></el-option>
            <el-option label="5" value="5"></el-option>
            <el-option label="6" value="6"></el-option>
            <el-option label="7" value="7"></el-option>
            <el-option label="8" value="8"></el-option>
            <el-option label="9" value="9"></el-option>
            <el-option label="10" value="10"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="发生区域" prop="cameraAlias">
					<el-input v-model="selectForm.cameraAlias" size="small" placeholder="请输入"></el-input>
				</el-form-item>
        <el-form-item label="处理结果" prop="result">
					<!-- <el-input v-model="selectForm.result" size="small" placeholder="请输入"></el-input> -->
          <el-select v-model="selectForm.result" placeholder="请选择">
						<el-option label="已处理" value="已处理"></el-option>
						<el-option label="未处理" value="未处理"></el-option>
					</el-select>
				</el-form-item>
        <!-- <el-form-item label="处理状态" prop="status">
					<el-select v-model="selectForm.status" placeholder="请选择" style="width: 100px;">
						<el-option label="1" value="1"></el-option>
						<el-option label="2" value="2"></el-option>
					</el-select>
				</el-form-item> -->
        <el-form-item>
          <el-button size="small" type="primary" @click="getAll">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button
            size="small"
            type="primary"
            @click="
              $refs.selectForm.resetFields();
              query();
            "
            >重置</el-button
          >
        </el-form-item>
        <!-- <el-form-item>
					<el-button size="small" type="primary" @click="dc">导出</el-button>
				</el-form-item> -->
      </el-form>
      <div>{{ huizong }}</div>
    </div>

    <!-- 表格 -->
    <el-table :data="data" style="width: 100%" v-loading="loading">
      <el-table-column prop="startTime" label="发生时间" align="center" width="160">
        <template slot-scope="{ row }">{{ row.startTime ? row.startTime.split("T")[0] + "
					"+row.startTime.split("T")[1].split(".")[0]:""}}</template>
      </el-table-column>
      <el-table-column
        prop="actionNumber"
        label="事件编号"
        align="center"
      ></el-table-column>
      <el-table-column prop="eventDesc" label="事件类型" align="center"></el-table-column>
      <el-table-column prop="grade" label="事件等级" align="center"></el-table-column>
      <el-table-column
        prop="cameraAlias"
        label="发生区域"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="actionCameraIp"
        label="相机IP"
        align="center"
      ></el-table-column>
      <!-- <el-table-column prop="isRemind" label="是否提醒保安" align="center">
				<template slot-scope="{row}">{{ row.isRemind ? "是" : "否" }}</template>
			</el-table-column>
			<el-table-column prop="remindType" label="提醒类型" align="center"></el-table-column>
			<el-table-column prop="remindTime" label="提醒时间" align="center">
				<template slot-scope="{row}">{{ row.remindTime ? row.remindTime.split("T")[0] : "" }}</template>
			</el-table-column>
			<el-table-column prop="isResponse" label="保安是否响应" align="center">
				<template slot-scope="{row}">{{ row.isResponse ? "是" : "否" }}</template>
			</el-table-column> -->
      <!-- <el-table-column v-if="statusAll == 2" prop="status" label="处理结果" align="center"></el-table-column> -->
      <el-table-column prop="result" label="处理结果" align="center"></el-table-column>
      <el-table-column v-if="statusAll == 1" label="操作" align="center">
        <template slot-scope="scope">
          <el-button v-if="statusAll == 1" type="text" @click="getRow2(scope.row)"
            >处理</el-button
          >
          <!-- <el-button v-if="scope.row.actionVideoPath != ''" type="text"
						@click="getRow(scope.row)">查看视频</el-button> -->
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <el-pagination
      v-if="totalNum > 0"
      @size-change="sizeChange"
      @current-change="currentChange"
      :page-sizes="[10, 20, 30, 40]"
      :page-size="selectForm.rows"
      layout="total, sizes, prev, pager, next, jumper"
      :total="totalNum"
      :current-page="selectForm.page"
      style="margin-top: 10px"
    >
    </el-pagination>
  </div>
</template>

<script>
import publicExport from "../../assets/js/publicExport.js";
export default {
  data() {
    return {
      loading: false,
      actionVideoPath: "",
      id: "",
      resultDesc: "",
      show2: false,
      title2: "",
      statusAll: "1",
      form: {
        //表单数据
        name: "",
        age: "",
      },
      data: [], //表格数据
      time: [], //时间
      selectForm: {
        //查询条件
        actionCameraIp: "",
        cameraAlias: "",
        page: 1, //当前页
        rows: 10, //页大小
        startTime: "", //开始时间
        endTime: "", //结束时间
        actionType: "", //事件类型
        actionLevel: "", //事件等级
        status: false, //处理结果
        cameraAlias: '',
        result: ''
      },
      totalNum: 0, //数据总数
      show: false, //控制弹窗
      title: "",
      disable: false, //节流
      typeList: [],
      huizong: ""
    };
  },
  methods: {
    getTypeList() {
      this.$http.post(`/api/safe/eventGrade/pageQuery`, {}).then((res) => {
        if (res.data.code == 200) {
          this.typeList = res.data.rows;
        }
      });
    },
    submitText() {
      if (this.resultDesc == "") {
        this.$message.error("请输入处理结果内容，可为：无");
        return;
      }
      this.$http
        .post(`/api/safe/securityIncident/handle`, {
          id: this.id,
          resultDesc: this.resultDesc,
          status: true,
        })
        .then((res) => {
          if (res.data.code == 200) {
            this.show2 = false;
            this.$message.success(res.data.msg);
            this.$parent.$parent.getNum();
            this.getAll();
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    dc() {
      publicExport("/api/export/uploadSecurityIncident", this.selectForm, "安全事件");
    },
    getRow(row) {
      //修改被点击
      this.title = "查看视频";
      // this.actionVideoPath = "http://clips.vorwaerts-gmbh.de/big_buck_bunny.mp4";
      this.actionVideoPath = row.actionVideoPath;
      this.show = true;
    },
    getRow2(row) {
      //修改被点击
      this.title2 = "处理";
      this.resultDesc = "";
      this.id = row.id;
      this.show2 = true;
    },
    close() {
      //弹框关闭
      this.$refs.form.resetFields();
    },
    getAll() {
      //获取表格数据
      this.loading = true;
      this.data = [];
      this.totalNum = 0;
      this.selectForm.startTime = "";
      this.selectForm.endTime = "";
      if (this.time && this.time.length != 0) {
        this.selectForm.startTime = this.time[0];
        this.selectForm.endTime = this.time[1];
      }
      if (this.statusAll == 1) {
        this.selectForm.status = false;
      } else {
        this.selectForm.status = true;
      }
      this.$http
        .post(
          `/api/safe/securityIncident/pageQuery?pageNum=${this.selectForm.page}&pageSize=${this.selectForm.rows}`,
          this.selectForm
        )
        .then((res) => {
          this.loading = false;
          if (res.data.code == 200) {
            this.data = res.data.rows;
            this.totalNum = res.data.total;
            this.huizong = res.data.huizong;
          } else {
            this.$message.error("查询失败");
          }
        });
    },
    query() {
      this.time = [];
      this.selectForm.page = 1;
      this.getAll();
    },
    sizeChange(rows) {
      //页大小被修改
      this.selectForm.rows = rows;
      this.getAll();
    },
    currentChange(page) {
      //当前页被修改
      this.selectForm.page = page;
      this.getAll();
    },
  },
  created() {
    this.getAll();
    this.getTypeList();
  },
};
</script>

<style scoped="scoped"></style>
